import {
  AcceptInvitationData,
  AcceptInvitationVars,
  InvitationParamsData,
  InvitationParamsVars
} from '../gql-types';
import { useMutation, useQuery } from '@apollo/client';

import { PublicGraphQL } from '../gql';

const useInvitation = (token: string) => {
  const {
    loading: paramsLoading,
    data: paramsData,
    error: paramsError
  } = useQuery<InvitationParamsData, InvitationParamsVars>(
    PublicGraphQL.Query.INVITATION_PARAMS,
    {
      skip: !token,
      variables: { token }
    }
  );

  const [
    acceptInvitation,
    { loading: acceptLoading, error: acceptError, data: acceptData }
  ] = useMutation<AcceptInvitationData, AcceptInvitationVars>(
    PublicGraphQL.Mutation.ACCEPT_INVITATION
  );

  return {
    paramsLoading,
    invitation: paramsData?.invitationParams,
    paramsError,
    acceptInvitation,
    acceptLoading,
    acceptError,
    accepted: acceptData?.acceptInvitation
  };
};

export default useInvitation;
